import { DaysBetween } from '../../utils/dateUtils';
import { SumWindow } from './SumWindow';

/**
 * Média por dia no período ativo (periodStart..periodEnd).
 * Sempre divide por daysBetween (não por dailyByDate.size) — assim dias sem
 * venda CONTAM como zero, refletindo a "média real do período".
 */
export function AvgPeriod(dailyByDate, ctx) {
    if (!ctx?.periodStartIso || !ctx?.periodEndIso) return 0;
    const total = SumWindow(dailyByDate, ctx.periodStartIso, ctx.periodEndIso);
    const days = DaysBetween(ctx.periodStartIso, ctx.periodEndIso);
    if (days <= 0) return 0;
    return total / days;
}
